/* ── Flexnet statuses ── */

export const Statuses = {
	Queued: {
		id: "eeb9cd55-4536-4b3c-9c47-3145a25d7bee",
		definition: "Containment is uploaded to MCC, but not yet in Flexnet (FN).",
	},
	Staged: {
		id: "508b5c13-1499-4d9d-b1d2-ae50076918dd",
		definition: "Serial number is in the Local Stage Table but hasn\u2019t been scanned or found in FN.",
	},
	Contained: {
		id: "d14fe56b-0f9b-4a77-b477-1aa7b733ccb2",
		definition: "Serial number is in \u201cSoft Containment/Soft Hold\u201d and has been scanned or located in FN. It doesn\u2019t stop the line.",
	},
	Held: {
		id: "63226880-17e1-45dc-9d81-8d35b81a79ad",
		definition: "Serial number is on Flexnet HOLD, will impact the line based on host query and BOM validation set up.",
	},
	Released: {
		id: "ae4886a9-ad60-4c7d-9ded-b0d38782f685",
		definition: "Will not remove from the local list in Flexnet. Serial number is cleared and can proceed in the build process.",
	},
} as const;

/* ── ASRS LPN statuses ── */

export const AsrsStatuses = {
	"Queued To Locked": {
		id: "71e8c4d2-3f5a-4b9e-9c1d-2e3f4a5b6c01",
		definition: "LPN queued transitioning to locked.",
	},
	"Queued To Unlocked": {
		id: "71e8c4d2-3f5a-4b9e-9c1d-2e3f4a5b6c02",
		definition: "LPN queued transitioning to unlocked.",
	},
	Locked: {
		id: "4b2f5fba-c275-4d5a-8cbf-055363f32033",
		definition: "LPN locked.",
	},
	Unlocked: {
		id: "dd5cecba-7a7d-42c5-be83-a19fc6846698",
		definition: "LPN unlocked.",
	},
	"Not Found Locked": {
		id: "71e8c4d2-3f5a-4b9e-9c1d-2e3f4a5b6c03",
		definition: "LPN not found, locked.",
	},
	"Not Found Unlocked": {
		id: "71e8c4d2-3f5a-4b9e-9c1d-2e3f4a5b6c04",
		definition: "LPN not found, unlocked.",
	},
	Pulled: {
		id: "71e8c4d2-3f5a-4b9e-9c1d-2e3f4a5b6c05",
		definition: "LPN pulled.",
	},
	"Viadat Unlocked": {
		id: "71e8c4d2-3f5a-4b9e-9c1d-2e3f4a5b6c06",
		definition: "LPN Viadat unlocked.",
	},
} as const;

/* ── Shared status definition shape ── */

export interface StatusDefinition {
	readonly id: string;
	readonly definition: string;
}

export type StatusEntries = [string, StatusDefinition][];

export function GetStatusEntriesForHoldSystem(holdSystemName: string): StatusEntries {
	if (holdSystemName.toLowerCase() === "asrs") {
		return AsrsStatuses.Entries() as StatusEntries;
	}
	return Statuses.Entries() as StatusEntries;
}

/* ── Types ── */

export type PartSerialStatusName = keyof typeof Statuses
export type PartSerialStatusId = (typeof Statuses)[keyof typeof Statuses]["id"];

export type AsrsStatusName = keyof typeof AsrsStatuses
export type AsrsStatusId = (typeof AsrsStatuses)[keyof typeof AsrsStatuses]["id"];

export type AnyStatusId = PartSerialStatusId | AsrsStatusId;

